import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { BellRing, Trash2 } from 'lucide-react';
import api from '@/lib/api';

const KEY = 'og_reminder_prompt';

export function triggerReminderPrompt(supplier) {
  sessionStorage.setItem(KEY, JSON.stringify({ supplier }));
  window.dispatchEvent(new CustomEvent('og-reminder-prompt'));
}

export default function ReminderPrompt() {
  const [supplier, setSupplier] = useState(null);

  useEffect(() => {
    const check = () => {
      try {
        const raw = sessionStorage.getItem(KEY);
        if (raw) setSupplier(JSON.parse(raw).supplier);
      } catch (e) { console.error('Failed to fetch reminder counts:', e); }
    };
    check();
    window.addEventListener('og-reminder-prompt', check);
    return () => window.removeEventListener('og-reminder-prompt', check);
  }, []);

  const dismiss = () => { sessionStorage.removeItem(KEY); setSupplier(null); };

  const deleteAll = async () => {
    try {
      const { data } = await api.delete(`/reminders/supplier/${encodeURIComponent(supplier)}`);
      toast.success(`Deleted ${data.deleted} reminder(s) for ${supplier}`);
    } catch {
      toast.error('Could not delete reminders');
    }
    dismiss();
  };

  if (!supplier) return null;

  return (
    <div data-testid="reminder-prompt-banner" className="fixed bottom-0 left-1/2 -translate-x-1/2 z-50 mb-4 mx-4 max-w-lg w-[calc(100%-2rem)] border border-amber-300 bg-white shadow-xl animate-fade-in">
      <div className="flex items-center gap-3 px-4 py-3 flex-wrap">
        <BellRing className="h-4 w-4 text-amber-600 shrink-0" />
        <p className="text-sm text-zinc-700 flex-1 min-w-[180px]">
          Done with <span className="font-semibold">{supplier}</span>'s reminders? Delete them now or keep them for next time.
        </p>
        <div className="flex items-center gap-2">
          <button data-testid="reminder-prompt-keep" onClick={dismiss}
            className="text-xs font-semibold px-3 py-1.5 border border-zinc-300 text-zinc-600 hover:bg-zinc-50 transition-colors">
            Keep them
          </button>
          <button data-testid="reminder-prompt-delete" onClick={deleteAll}
            className="flex items-center gap-1 text-xs font-semibold px-3 py-1.5 bg-red-600 text-white hover:bg-red-700 transition-colors">
            <Trash2 className="h-3 w-3" /> Delete all
          </button>
        </div>
      </div>
    </div>
  );
}
